// extracted by mini-css-extract-plugin
export default {"noteHeader":"notesTabContent_noteHeader__UdNAd","noteContent":"notesTabContent_noteContent__-vEmV"};